import { render, staticRenderFns } from "./WayPoint.vue?vue&type=template&id=46b2a20d&scoped=true"
import script from "./WayPoint.vue?vue&type=script&lang=js"
export * from "./WayPoint.vue?vue&type=script&lang=js"
import style0 from "./WayPoint.vue?vue&type=style&index=0&id=46b2a20d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b2a20d",
  null
  
)

export default component.exports